import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getUserListApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `user?` + params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
